// extracted by css-extract-rspack-plugin
export default {"squareBanner":"TransactionalMessageBanner-module__squareBanner__X2JZTos"};